/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'market-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M21.51 12.353a4.538 4.538 0 0 1-3.022-1.163 4.43 4.43 0 0 1-3.006 1.163 4.49 4.49 0 0 1-2.995-1.162 4.434 4.434 0 0 1-3.005 1.162 4.489 4.489 0 0 1-3-1.167 4.54 4.54 0 0 1-3.027 1.167c-.504 0-1.455-.09-1.455-.247V22.5A1.5 1.5 0 0 0 3.5 24H5v-8a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v8h9.5a1.5 1.5 0 0 0 1.5-1.5V12.104c0 .161-.97.249-1.49.249zM18.5 22h-3a.5.5 0 1 1 0-1h3a.5.5 0 0 1 0 1zm.5-4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zM21.197.684A1 1 0 0 0 20.248 0H5.69a1 1 0 0 0-.949.684L4.302 2h17.334z"/><path pid="1" d="M24.788 7.17L22.38 3H3.435L.34 7a2.447 2.447 0 0 0-.193 2.074 3.53 3.53 0 0 0 6.336.553 3.47 3.47 0 0 0 6 0 3.47 3.47 0 0 0 6 0 3.528 3.528 0 0 0 6.457-.954 2.38 2.38 0 0 0-.152-1.504z"/>'
  }
})
